import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { whatsappLink } from "@/lib/scroll";

export default function WhatsAppButton() {
  const { t } = useTranslation();
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={whatsappLink(t("whatsapp.message"))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsapp.aria")}
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_28px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <span className="absolute -top-0.5 -right-0.5 flex h-3.5 w-3.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F5CB5C] opacity-75" />
        <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-[#F5CB5C] border-2 border-[#05070A]" />
      </span>
      <MessageCircle size={26} className="text-white" fill="white" />
    </a>
  );
}
